import { InfoBox } from '@cdm/quickenloans-library/lib';
import { domToReact } from 'html-react-parser';
import PropTypes from 'prop-types';
import React from 'react';
import { findDomElementFilterFn } from '../../../../findDomElement';
import { wpClassNames } from './Constants';

const filterByClassName = (className) => (element) => element.attribs?.class?.includes(className);

const toCalloutBox = ( parserData ) =>
{
    const { parserOptions: {replaceFn} } = parserData;
    const Wrapper = ({ name = '', type = '', attribs = {}, children }) =>
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'div') return null;
        if (!('data-type' in attribs)) return null;

        const containerClassNames = attribs?.class?.split(' ') || [];
        if (!containerClassNames.includes(wpClassNames.CALLOUT_BOX_CONTAINER)) return null;

        const filteredContent = children?.filter(
            child => child.type === 'tag'
            && child.name === 'div'
            && child?.attribs?.class.includes(wpClassNames.CALLOUT_BOX_CONTENT)
        );
        if (!Array.isArray(filteredContent)) return null;

        const content = filteredContent.at(0);
        if (!Array.isArray(content?.children)) return null;

        const titleContainer = findDomElementFilterFn({ element: content, filterFn: filterByClassName(wpClassNames.CALLOUT_BOX_TITLE) });
        const convertedTitle = titleContainer ? domToReact([titleContainer], replaceFn()) : null;
        
        const boxContentItems = Array.isArray(content?.children)
            ? content?.children.filter((child) =>
            {
                if ((!child.name || child.name !== 'span') &&
                    !findDomElementFilterFn({ element: child, filterFn: filterByClassName(wpClassNames.CALLOUT_BOX_TITLE) })
                ) return true;

                return false;
            })
            : content?.children;

        let convertedContent = domToReact(boxContentItems, replaceFn());
        if (
            !Array.isArray(convertedContent) && typeof convertedContent !== 'string'
        ) 
        {
            convertedContent = [convertedContent];
        }

        return (
            <InfoBox items={[
                (convertedTitle || null),
                convertedContent
            ]}/>
        );
    }

    Wrapper.propTypes = {
        name: PropTypes.oneOf(['div']),
        type: PropTypes.oneOf(['tag']),
        attribs: PropTypes.shape({
            class: PropTypes.string,
            id: PropTypes.string
        }),
    };

    return Wrapper;
};

export default toCalloutBox;
